import { Component } from '@angular/core';
import { AuthenticationService } from '../../libraries/libraries.module';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  constructor(public _authentication: AuthenticationService) {}
}
